// extracted by mini-css-extract-plugin
export var quillEditor = "_nx-1";
export var variable = "_nx-0";